module.exports = __webpack_public_path__ + "static/google-1c88acdbdbe592c5f339cc59f1897084.png";